import axios from "axios";
import { toast } from "react-toastify";

import {
  getToken,
  removeToken,
  removePermissions,
  removeUserData,
} from "@utils/commonFunctions";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(
  function (config) {
    config.headers.Authorization = `Bearer ${getToken()}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          window.location.href = "/login";
          removeToken();
          removePermissions();
          removeUserData();
          return Promise.reject(error);
        case 403:
          toast.error("You do not have permission to perform this action.");
          break;
        default:
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
